var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component",attrs:{"block-info":_vm.blockInfo,"blockDataInfo":_vm.blockDataInfo,"showTop":_vm.showTop,"topValue":_vm.topValue},on:{"clickItem":_vm.clickItem}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }